import convertToUrl from "helpers/convert-to-url";
import { slugify } from "src/utils/string";
import { currencyType } from "@/src/helpers/currency-type";
import { getPriceForProjects } from "./similar-listing-search";
import { calculateListingIndex } from "../event-helpers/handleGA4UndefinedValues";
import { eCommerceGa4ListIds } from "@/src/helpers/google-tag-manager/common";

export function getGa4ScrollViewEventInfo(item, index, type, searchId, similarCount, pageNumber) {
  const LIST_ID = similarCount
    ? eCommerceGa4ListIds["ilan-listeleme/benzer-ilanlar"]
    : eCommerceGa4ListIds["ilan-listeleme"];
  const LIST_NAME = similarCount ? "ilan-listeleme/benzer-ilanlar" : "ilan-listeleme";

  if (type === "proje") {
    const currency = item?.price?.currency ?? item?.price?.priceSummary?.currency ?? "TRY";

    return {
      search_id: searchId,
      item_price: getPriceForProjects(item?.price),
      item_id: `${item?.id ?? ""}`,
      item_name: convertToUrl(item?.name ?? ""),
      currency: currencyType(currency, true),
      discount: 0.0,
      index: pageNumber > 0 ? calculateListingIndex(index, pageNumber) : index,
      item_brand: "proje",
      item_category: slugify(item?.category?.slug),
      item_category2: slugify(item?.estateType?.slug),
      item_category3: slugify(item?.locationInfo?.cityName),
      item_category4: slugify(item?.locationInfo?.districtName),
      item_category5: undefined,
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      item_variant: slugify(item?.tradeType?.name) || slugify(item?.tradeType?.slug),
      location_id: item?.locationInfo?.cityId ?? undefined,
      item_one_cikan: item?.campaigns?.includes("promotion") ? "yes" : "no",
      price: 0.0,
      quantity: 1,
    };
  } else {
    const priceVal = item?.priceDetail?.price ?? item?.price?.value ?? item?.price_order ?? 0;

    const currency = item?.priceDetail?.currency ?? item?.price?.currency ?? item?.price_order_currency ?? "TRY";

    const titleRaw = item?.title?.tr ?? item?.title ?? "";

    return {
      search_id: searchId,
      item_price: (Number(item?.price_order ?? priceVal) || 0).toFixed(2),
      item_id: `${item?.id ?? ""}`,
      item_name: convertToUrl(titleRaw),
      currency: currencyType(currency, true),
      discount: 0.0,
      index: pageNumber > 0 ? calculateListingIndex(index, pageNumber) : index,
      item_brand: "ilan",
      item_category: slugify(item?.categoryTypeName ?? item?.category),
      item_category2: slugify(item?.estateTypeName ?? item?.estateType),
      item_category3: slugify(item?.location?.city?.name ?? item?.location?.cityName),
      item_category4: slugify(item?.location?.district?.name ?? item?.location?.districtName),
      item_category5: slugify(item?.location?.town?.name ?? item?.location?.townName),
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      item_variant: slugify(item?.tradeTypeName ?? item?.tradeType),
      location_id: item?.location?.city?.id ?? item?.location?.cityId ?? undefined,
      item_one_cikan: item?.badges?.includes?.("promotion") ? "yes" : "no",
      price: 0.0,
      quantity: 1,
    };
  }
}
